
<dx-data-grid
  [dataSource]="dataSource"
  [showBorders]="true"
  [columnAutoWidth]="true"
  (onInitNewRow)="onInitNewRow($event)"
  (onExporting)="onExporting($event)">

  <dxo-export [enabled]="true"></dxo-export>
  <dxo-editing
    mode="row"
    [allowAdding]="true"
    [allowUpdating]="false"
    [allowDeleting] ="true"
    [useIcons]="true"
    >
    <dxo-texts confirmDeleteMessage="Vuoi eliminare l'allegato?"></dxo-texts>
  </dxo-editing>
  <dxi-column dataField="id" [visible]="false"></dxi-column>

  <dxi-column
    name="scaricaFile"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="scaricaFile"
    caption=""
    width="25">
  </dxi-column>
  <dxi-column
    name="vediFile"
    [allowFiltering]="false"
    [allowSorting]="false" cellTemplate="vediFile"
    caption=""
    width="25">
  </dxi-column>
  <dxi-column dataField="nome"></dxi-column>
  <div *dxTemplate="let d of 'scaricaFile'">
    <i class="dx-icon-download"
    (click)="scaricaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Scarica allegato"></i>
  </div>
  <div *dxTemplate="let d of 'vediFile'">
    @if (endsWith(d.data.nomeFile, '.jpg') || endsWith(d.data.nomeFile, '.png')) {
      <i class="dx-icon-image"
      (click)="visualizzaImmagine(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Visualizza immagine"></i>
    }
    @if (endsWith(d.data.nomeFile, '.pdf')) {
      <i class="dx-icon-doc"
      (click)="visualizzaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Visualizza allegato"></i>
    }
  </div>

</dx-data-grid>

<dx-popup
  [width]="600"
  [height]="450"
  [showTitle]="true"
  title=""
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [(visible)]="popupImageVisible">
  <img style="max-width: 100%; max-height: 100%;" [src]="currentImage" alt="Allegato Immagine">
</dx-popup>

@if (popupAddAllegatoDipendenteVisible) {
  <app-popup-add-allegato-dipendente
    [dipendente]="dipendente"
    (popupAddAllegatoDipendenteEventEmitter)="onPopupAddAllegatoDipendenteEvent($event)">
  </app-popup-add-allegato-dipendente>
}